import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import styles from './imgList.scss';
import axios from 'axios';
import { Spin } from 'antd';
import 'antd/dist/antd.css';
import { download } from '../func';
import ZoomPic from './zoomPic';
import objectFitImages from 'object-fit-images';
import LazyImage from '../LazyImg';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const PAGE_SIZE = 30;

function isIE() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf("MSIE ");

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    return true;
  } else {
    return false;
  }
}

function ImgList(props) {
  const [mainContainer, setMainContainer] = useState(null);
  const [curIndex, setCurIndex] = useState(0);
  const [data, setData] = useState(null);
  const [cities, setCities] = useState(null);
  const [pictures, setPictures] = useState(null);
  const [page, setPage] = useState(0);
  const [isLoading, setIsloading] = useState(false);
  const [picViewerIndex, setPicViewerIndex] = useState(null);

  // 窗口大小变化
  const handleResize = () => {
    const mainContainer = document.getElementById('imgList');
    setMainContainer({
      width: mainContainer.offsetWidth - 60,
      height: mainContainer.offsetHeight,
    });
  };

  useEffect(() => {
    if (isIE()) {
      setInterval(() => {
        const imgs = document.querySelectorAll('img');
        objectFitImages(imgs);
      }, 100);
    }

    axios.get(`https://statics.wow-trend.com/wow-trend-cn/json/${props.match.params.id}.json`).then(res => {
      const data = res.data;
      if (data) {
        setData(data);
        const cities = data.cities;
        setCities(cities);
        setPictures(cities[0].pictures);

        setTimeout(() => {
          handleResize();
          window.addEventListener('resize', handleResize);

          const imgList = document.getElementById('imgList');
          const main = document.getElementById('imgList-main');
          if (!imgList) return;
          const scrollFunc = _.debounce(() => {
            if (imgList.clientHeight + imgList.scrollTop >= (main.clientHeight - 5)) {
              setPage(page => page + 1);

              setTimeout(() => {
                const imgs = document.querySelectorAll('img');
                objectFitImages(imgs);
              }, 300);
            }
          }, 300);
          imgList.addEventListener('scroll', scrollFunc);

          setTimeout(() => {
            const imgs = document.querySelectorAll('img');
            objectFitImages(imgs);
          }, 300);
        }, 300);
      }
    });
  }, []);

  const picturesRef = useRef(null);
  const picViewerIndexRef = useRef(null);
  useEffect(() => {
    picturesRef.current = pictures;
  }, [pictures]);
  useEffect(() => {
    picViewerIndexRef.current = picViewerIndex;
  }, [picViewerIndex]);

  useEffect(() => {
    const func = e => {
      const picViewerIndex = picViewerIndexRef.current;
      const pictures = picturesRef.current;

      if (picViewerIndex === null) return;

      if (e.keyCode === 39) {
        if (picViewerIndex < pictures.length - 1) {
          setPicViewerIndex(index => index + 1);
        }
      }

      if (e.keyCode === 37) {
        if (picViewerIndex > 0) {
          setPicViewerIndex(index => index - 1);
        }
      }
    };

    window.addEventListener('keydown', func);
  }, [])

  const listWidth = mainContainer && mainContainer.width;

  if (!data || !pictures) return null;

  let _pictures = null;
  if ((page + 1) * PAGE_SIZE < pictures.length) {
    _pictures = pictures.slice(0, (page + 1) * PAGE_SIZE - 1);
  } else {
    _pictures = pictures;
  }

  return (
    <div className={styles.imgList}>
      <div className={styles.header}>
        <nav className={styles.nav}>
          <ul id='header-tagList' className={styles.tagList}>
            {
              cities && cities.map((item, index) => {
                return (
                  <li
                    key={index}
                    className={`${styles.item} ${curIndex === index ? styles.active : ''}`}
                    onClick={e => {
                      e.stopPropagation();

                      if (index === curIndex) return;
                      setIsloading(true);
                      setCurIndex(index);
                      setPictures(cities[index].pictures);
                      setPage(0);
                      setTimeout(() => {
                        setIsloading(false);
                      }, 300);

                      //当前active item展示不全时滚动父元素
                      const parent = document.getElementById('header-tagList');
                      if (parent) {
                        const target = parent.childNodes[index];
                        if (target) {
                          const parentWidth = parent.offsetWidth;
                          const parentScrollLeft = parent.scrollLeft;
                          const targetOffsetLeft = target.offsetLeft;
                          const targetWidth = target.offsetWidth;

                          if (targetOffsetLeft + targetWidth - parentScrollLeft > parentWidth) {
                            parent.scrollLeft = parent.scrollLeft + 1000;
                          }

                          if (targetOffsetLeft - parentScrollLeft < 0) {
                            parent.scrollLeft = parent.scrollLeft - 1000;
                          }
                        }
                      }
                    }}
                  >
                    {item.title}
                  </li>
                );
              })
            }
          </ul>
        </nav>
      </div>

      <div id='imgList' className={styles.main}>
        {
          !mainContainer ? null :
            isLoading ? <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center' }}><Spin style={{ marginTop: '20px' }} /></div> :
              <div id='imgList-main' className={styles.list}>
                <div
                  key={-1}
                  className={styles.imgWrap}
                  style={{
                    width: `${(listWidth - 4) / 4}px`,
                    height: `${(listWidth - 4) / 4}px`,
                  }}
                >
                  <div className={styles.detail}>
                    <div className={styles.title}>{data.title}</div>

                    <div className={styles.date}>{data.time}</div>

                    <div className={styles.line} />

                    <div className={styles.desc} dangerouslySetInnerHTML={{ __html: data.desc }} />
                  </div>
                </div>

                {
                  _pictures.map((item, index) => {
                    return (
                      <div
                        className={styles.imgWrap}
                        style={{
                          width: `${(listWidth - 4) / 4}px`,
                          height: `${(listWidth - 4) / 4}px`,
                        }}
                        key={index}
                      >
                        <div
                          className={styles.picture}
                          onClick={() => setPicViewerIndex(index)}
                        // style={{ backgroundImage: `url(${item.preview_picture})` }}
                        >
                          <LazyLoadImage src={item.preview_picture} />

                          {/* <LazyImage
                            srcset={item.preview_picture}
                          /> */}

                          <div className={styles.cover}></div>

                          <i
                            className={`iconfont icontongyong_xiazai ${styles.download}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              download(item.hd_picture);
                            }}
                          />
                        </div>
                      </div>
                    );
                  })
                }
              </div>
        }
      </div>

      <div className={`${styles.picViewer} ${picViewerIndex === null ? '' : styles.active}`}>
        <div
          className={styles.imgWrap}
        // style={{
        //   backgroundImage: _pictures && picViewerIndex !== null ? `url(${_pictures[picViewerIndex].hd_picture})` : ''
        // }}
        >
          {/* {_pictures && picViewerIndex !== null && <img src={_pictures[picViewerIndex].hd_picture} />} */}

          <div style={{ width: '100%', height: '100%', display: _pictures && picViewerIndex !== null ? 'block' : 'none' }}>
            <ZoomPic path={_pictures && picViewerIndex !== null ? _pictures[picViewerIndex].hd_picture : ''} setImgSize={() => { }} reset={() => { }} />
          </div>
        </div>

        <div onClick={() => setPicViewerIndex(null)} className={styles.close}>
          <i className="iconfont iconxiangqingdanchuang-guanbi"></i>
        </div>

        {
          picViewerIndex > 0 ?
            <div
              onClick={() => setPicViewerIndex(index => index - 1)}
              className={styles.prevPage}
            >
              <i className="iconfont iconlanmuye_xiaotubiao_bannerfanyeyouzuo"></i>

              <div className={styles.prevImgBox}>
                <img src={_pictures[picViewerIndex - 1].preview_picture} />
                <div className={styles.imgMask}>
                  <span>上一张</span>
                </div>
              </div>
            </div> : null
        }

        {
          picViewerIndex < _pictures.length - 1 ?
            <div
              onClick={() => setPicViewerIndex(index => index + 1)}
              className={styles.nextPage}
            >
              <i className="iconfont iconlanmuye_xiaotubiao_bannerfanyeyou"></i>

              <div className={styles.nextImgBox}>
                <img src={_pictures[picViewerIndex + 1].preview_picture} />
                <div className={styles.imgMask}>
                  <span>下一张</span>
                </div>
              </div>
            </div> : null
        }
      </div>
    </div>
  );
}

export default ImgList;